import { render, staticRenderFns } from "./fees_payments.vue?vue&type=template&id=26568e76&"
import script from "./fees_payments.vue?vue&type=script&lang=js&"
export * from "./fees_payments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports